import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { getSelectedTitle } from '!views/Market/StockExchange/marketStockExchange.seletors';
import { uuidSelector } from '»components/Auth';

import { trlDetailsServices } from './trlDetails.services';
import {
  ButtonStyled,
  SelectionStyled,
  TableBodyStyled,
  TableCellStyled,
  TableHeadStyled,
  TableRowStyled,
  Tables,
  TableStyled,
  Wraper,
} from './TrlDetails.styles';

export const MarketDepht = () => {
  const [dephtData, setDephtData] = useState([]);

  const selectedTitle = useSelector(getSelectedTitle);
  const uuid = useSelector(uuidSelector);

  const callService = async (a, b, c) => {
    const response = await trlDetailsServices.instrumentMarketDepth({
      symbol: a,
      exchange: b,
      securityType: c,
    });
    response.map((el) => {
      setDephtData(el);
      return el;
    });
  };

  const selectedTitleExists = Object.keys(selectedTitle).length > 0;

  useEffect(() => {
    if (selectedTitleExists)
      callService(
        selectedTitle.symbol,
        selectedTitle.exchange,
        selectedTitle.securityType,
      );
  }, [
    selectedTitle.symbol,
    selectedTitle.exchange,
    selectedTitle.securityType,
    selectedTitleExists,
    uuid,
  ]);

  return (
    <Wraper>
      <SelectionStyled>
        <ButtonStyled disabled>
          <FormattedMessage id="TRLT_UI-BEST_BID" />
        </ButtonStyled>
        <ButtonStyled disabled>
          <FormattedMessage id="TRLT_UI-BEST_ASK" />
        </ButtonStyled>
      </SelectionStyled>
      <Tables>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled uppercased>
                <FormattedMessage id="TRLT_UI-NC" />
              </TableCellStyled>
              <TableCellStyled>
                <FormattedMessage id="TRLT_UI-QUANTITY" />
              </TableCellStyled>
              <TableCellStyled>
                <FormattedMessage id="TRLT_UI-PRICE" />
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            <TableRowStyled>
              <TableCellStyled>
                {dephtData.bidSize1 !== undefined ? dephtData.bidSize1 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.bidQty1 !== undefined ? dephtData.bidQty1 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.bidPx1 !== undefined ? dephtData.bidPx1 : 0}
              </TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled>
                {dephtData.bidSize2 !== undefined ? dephtData.bidSize2 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.bidQty2 !== undefined ? dephtData.bidQty2 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.bidPx2 !== undefined ? dephtData.bidPx2 : 0}
              </TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled>
                {dephtData.bidSize3 !== undefined ? dephtData.bidSize3 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.bidQty3 !== undefined ? dephtData.bidQty3 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.bidPx3 !== undefined ? dephtData.bidPx3 : 0}
              </TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled>
                {dephtData.bidSize4 !== undefined ? dephtData.bidSize4 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.bidQty4 !== undefined ? dephtData.bidQty4 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.bidPx4 !== undefined ? dephtData.bidPx4 : 0}
              </TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled>
                {dephtData.bidSize5 !== undefined ? dephtData.bidSize5 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.bidQty5 !== undefined ? dephtData.bidQty5 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.bidPx5 !== undefined ? dephtData.bidPx5 : 0}
              </TableCellStyled>
            </TableRowStyled>
          </TableBodyStyled>
        </TableStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled>
                <FormattedMessage id="TRLT_UI-PRICE" />
              </TableCellStyled>
              <TableCellStyled>
                <FormattedMessage id="TRLT_UI-QUANTITY" />
              </TableCellStyled>
              <TableCellStyled uppercased>
                <FormattedMessage id="TRLT_UI-NV" />
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled className="rightCollum">
            <TableRowStyled>
              <TableCellStyled>
                {dephtData.askPx1 !== undefined ? dephtData.askPx1 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.askQty1 !== undefined ? dephtData.askQty1 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.askSize1 !== undefined ? dephtData.askSize1 : 0}
              </TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled>
                {dephtData.askPx2 !== undefined ? dephtData.askPx2 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.askQty2 !== undefined ? dephtData.askQty2 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.askSize2 !== undefined ? dephtData.askSize2 : 0}
              </TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled>
                {dephtData.askPx3 !== undefined ? dephtData.askPx3 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.askQty3 !== undefined ? dephtData.askQty3 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.askSize3 !== undefined ? dephtData.askSize3 : 0}
              </TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled>
                {dephtData.askPx4 !== undefined ? dephtData.askPx4 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.askQty4 !== undefined ? dephtData.askQty4 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.askSize4 !== undefined ? dephtData.askSize4 : 0}
              </TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled>
                {dephtData.askPx5 !== undefined ? dephtData.askPx5 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.askQty5 !== undefined ? dephtData.askQty5 : 0}
              </TableCellStyled>
              <TableCellStyled>
                {dephtData.askSize5 !== undefined ? dephtData.askSize5 : 0}
              </TableCellStyled>
            </TableRowStyled>
          </TableBodyStyled>
        </TableStyled>
      </Tables>
    </Wraper>
  );
};
